import { defineAsyncComponent } from 'vue'
export default {
  "base-layout": defineAsyncComponent(() => import("/app/layouts/BaseLayout.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/app/layouts/default.vue").then(m => m.default || m))
}